import styled from 'styled-components';
import {
  Navbar,
} from 'react-bootstrap';

/*
    navbar-toggle trnasition is defined here because the sequence of react-boostrap append classes.
    Write css transition in styled toggle will end up using lots of !important to override
    react-boostrap styles.
    Therefore I write the css transition logic of navbar-toggle here.
*/

const StyledNavbar = styled(Navbar)`
  min-height: 50px !important;

  @media screen and (min-width: 768px) {
    padding-top: 5px !important;
    padding-bottom: 5px !important;
  }

  //navbar-toggle animation
  .navbar-toggle span.icon-bar {
    -webkit-transition: all 0.15s;
    transition: all 0.15s;
  }

  .navbar-toggle span:nth-child(2) {
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    -webkit-transform-origin: 10% 10%;
    transform-origin: 10% 10%;
  }

  .navbar-toggle span:nth-child(3) {
    opacity: 0;
  }

  .navbar-toggle span:nth-child(4) {
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
    -webkit-transform-origin: 10% 90%;
    transform-origin: 10% 90%;
  }

  .navbar-toggle.collapsed span:nth-child(2),
  .navbar-toggle.collapsed span:nth-child(4) {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  .navbar-toggle.collapsed span:nth-child(3) {
    opacity: 1;
  }

  .navbar-nav > li > a {
    padding-top: 4px;
    padding-bottom: 4px;
    padding-left: 0;
    padding-right: 0;
    line-height: 54px;
    margin-left: 15px;
    margin-right: 15px;

    @media screen and (max-width: 414px) {
      text-align: center;
    }
  }

  .navbar-collapse, .navbar-default .navbar-form {
    @media screen and (max-width: 767px) {
      border-top: 1px solid white !important;
    }
  }
`;

export default StyledNavbar;




// WEBPACK FOOTER //
// ./src/components/shared/Nav/StyledNavbar.js